<template>
  <d-container fluid class="main-content-container px-4 pb-4">
    <!-- Page Header -->
    <d-row no-gutters class="page-header py-4">
      <!-- Page Title -->
      <d-col col sm="4" class="text-center text-sm-left mb-4 mb-sm-0">
        <span class="text-uppercase page-subtitle">Articles</span>
        <h3 class="page-title">{{ this.$route.params.pageTitle }}</h3>
      </d-col>
      <d-col> </d-col>
    </d-row>

    <p>
      <router-link to="/article"
        ><i class="material-icons mr-1">arrow_back</i>Back</router-link
      >
    </p>

    <d-alert
      dismissible
      :show="timeUntilDismissed"
      theme="success"
      @alert-dismissed="timeUntilDismissed = 0"
      @alert-dismiss-countdown="handleTimeChange"
    >
      <b>Success!</b> This alert will will be dismissed in
      {{ timeUntilDismissed }} seconds!
    </d-alert>

    <d-row>
      <!-- Editor -->
      <d-col lg="9" md="12">
        <d-tabs>
          <d-tab title="English" active>
            <d-card class="card-small mb-3">
              <d-card-body>
                <d-form class="add-new-post" accept-charset="UTF-8">
                  <d-input
                    size="lg"
                    class="mb-3"
                    v-model="title_ENG"
                    placeholder="Your Post Title"
                  />
                  <div>
                    <textarea
                      class="form-control"
                      ref="content"
                      v-model="content_ENG"
                      placeholder="Enter something"
                      rows="30"
                      cols="155"
                    >
                    </textarea>
                  </div>
                </d-form>
              </d-card-body>
            </d-card>
          </d-tab>
          <d-tab title="繁體">
            <d-card class="card-small mb-3">
              <d-card-body>
                <d-form class="add-new-post" accept-charset="UTF-8">
                  <d-input
                    size="lg"
                    class="mb-3"
                    v-model="title_CN_TRA"
                    placeholder="Your Post Title"
                  />
                  <div>
                    <textarea
                      class="form-control"
                      ref="content"
                      v-model="content_CN_TRA"
                      placeholder="Enter something"
                      rows="30"
                      cols="155"
                    >
                    </textarea>
                  </div>
                </d-form>
              </d-card-body>
            </d-card>
          </d-tab>
          <d-tab title="简体">
            <d-card class="card-small mb-3">
              <d-card-body>
                <d-form class="add-new-post" accept-charset="UTF-8">
                  <d-input
                    size="lg"
                    class="mb-3"
                    v-model="title_CN_SIM"
                    placeholder="Your Post Title"
                  />
                  <div>
                    <textarea
                      class="form-control"
                      ref="content"
                      v-model="content_CN_SIM"
                      placeholder="Enter something"
                      rows="30"
                      cols="155"
                    >
                    </textarea>
                  </div>
                </d-form>
              </d-card-body>
            </d-card>
          </d-tab>
        </d-tabs>
      </d-col>

      <!-- Sidebar Widgets -->
      <d-col lg="3" md="12">
        <!-- <anp-sidebar-actions /> -->
        <d-card class="card-small mb-3">
          <d-card-header class="border-bottom">
            <h6 class="m-0">{{ title_Action }}</h6>
          </d-card-header>

          <d-card-body class="p-0">
            <d-list-group flush>
              
              <d-list-group-item class="p-3">
                <span class="d-flex mb-2"
                  ><i class="material-icons mr-1">visibility</i
                  ><strong class="mr-1">Visibility:</strong>
                  <d-checkbox
                    toggle
                    class="custom-toggle-sm"
                    checked
                    v-model="enabled"
                  ></d-checkbox
                ></span>
              </d-list-group-item>

              <d-list-group-item class="d-flex px-3">
                <d-button size="sm" class="btn-outline-accent">
                  <i class="material-icons">save</i> Save Draft
                </d-button>
                
                <d-button
                  v-if="this.$route.params.creating"
                  size="sm"
                  class="btn-accent ml-auto"
                  @click.prevent="post()"
                >
                  <i class="material-icons">file_copy</i> Create
                </d-button>
                <d-button
                  v-else
                  size="sm"
                  class="btn-accent ml-auto"
                  @click.prevent="update()"
                >
                  <i class="material-icons">file_copy</i> Update
                </d-button>
              </d-list-group-item>
            </d-list-group>
          </d-card-body>
        </d-card>
        
        <!-- <anp-sidebar-category /> -->
        <d-card class="card-small mb-3">
          <!-- Card Header -->
          <d-card-header class="border-bottom">
            <h6 class="m-0">{{ title_Categories }}</h6>
          </d-card-header>

          <d-card-body class="p-0">
            <d-list-group flush>
              <!-- Categories -->
              <d-list-group-item class="px-3 pb-2">
                <d-form-radio
                  v-model="selected"
                  v-for="category in categories"
                  :value="category.id"
                  :key="category.id"
                  name="selected"
                  >{{ category.name }}</d-form-radio
                >
              </d-list-group-item>

              <!-- Add New Category -->
              <d-list-group-item class="px-3 pb-2">
                <d-input-group class="mb-2">
                  <d-input placeholder="New category" />
                  <d-input-group-addon append>
                    <d-button class="btn-white px-2"><i class="material-icons">add</i></d-button>
                  </d-input-group-addon>
                </d-input-group>
              </d-list-group-item>
            </d-list-group>
          </d-card-body>
        </d-card>
      </d-col>
    </d-row>
  </d-container>
</template>

<script>
import "quill/dist/quill.snow.css";
import axios from "axios";

export default {
  props: ["articleId", "pageTitle", "creating", "published"],
  data() {
    return {
      title_ENG: "",
      title_CN_TRA: "",
      title_CN_SIM: "",
      content_ENG: "",
      content_CN_TRA: "",
      content_CN_SIM: "",
      enabled: this.$route.params.published,
      title: "",
      content: "",
      selected: this.selected,
      categories: [],
      duration: 5,
      timeUntilDismissed: 0,
    };
  },
  methods: {
    handleTimeChange(time) {
      this.timeUntilDismissed = time;
    },
    post() {
      this.$confirm("Are you Create").then((response) => {
        axios
          .post(process.env.VUE_APP_API + "api/staff/Article", {
            translations: {
              en: {
                title: this.title_ENG,
                content: this.content_ENG,
              },
              zh_hans: {
                title: this.title_CN_SIM,
                content: this.content_CN_SIM,
              },
              zh_hant: {
                title: this.title_CN_TRA,
                content: this.content_CN_TRA,
              },
            },
            categoryId: this.selected,
            published: this.enabled,
        });
        this.$router.push({
          path: "/article",
        });
      });
    },
    update() {
      axios
        .put(
          process.env.VUE_APP_API +
            `api/staff/Article/${this.$route.params.id}`,
          {
            translations: {
              en: {
                title: this.title_ENG,
                content: this.content_ENG,
              },
              zh_hans: {
                title: this.title_CN_SIM,
                content: this.content_CN_SIM,
              },
              zh_hant: {
                title: this.title_CN_TRA,
                content: this.content_CN_TRA,
              },
            },
            categoryId: this.selected,
            published: this.enabled,
          }
        )
        .then((response) => {
          if (response.data.statusCode == 200) {
            this.timeUntilDismissed = this.duration;
          }
        })
        .catch((err) => {
          alert(err);
        });
    },
  },
  mounted: function () {
    axios
      .get(process.env.VUE_APP_API + "api/staff/Category")
      .then((response) => {
        this.categories = response.data.result.result;
      })
      .catch(function (error) {
        console.log(error);
      })
    if (this.$route.params.id) {
      axios
        .get(
          process.env.VUE_APP_API + `api/staff/Article/${this.$route.params.id}`
        )
        .then((response) => {
          var article = response.data.result;
          this.title_ENG = article.translations.en.title;
          this.content_ENG = article.translations.en.content;
          this.title_CN_SIM = article.translations.zh_hans.title;
          this.content_CN_SIM = article.translations.zh_hans.content;
          this.title_CN_TRA = article.translations.zh_hant.title;
          this.content_CN_TRA = article.translations.zh_hant.content;
          this.selected = article.categoryId;
        });
    }
  },
  props: {
    title_Action: {
      type: String,
      default: "Action",
    },
    title_Categories: {
      type: String,
      default: "Categories",
    },
  },
};
</script>